import { Link } from 'react-router-dom';

interface Category {
  name: string;
  url: string;
}

const featuredCategories: Category[] = [
  { name: 'Shoes', url: 'https://kaspreadsheet.com/category-911-Shoes.html' },
  { name: 'Hoodies & Sweaters', url: 'https://kaspreadsheet.com/search-912/name/Shoes.html' },
  { name: 'T-Shirts', url: 'https://kaspreadsheet.com/search-913/name/Shoes.html' },
  { name: 'Jackets', url: 'https://kaspreadsheet.com/search-914/name/Shoes.html' },
  { name: 'Bags', url: 'https://kaspreadsheet.com/search-921/name/Shoes.html' },
  { name: 'Accessories', url: 'https://kaspreadsheet.com/search-920/name/Shoes.html' },
];

const categoryImages: Record<string, string> = {
  'Shoes': 'https://readdy.ai/api/search-image?query=Pair%20of%20white%20leather%20sneakers%20placed%20on%20rustic%20wooden%20floor%20next%20to%20a%20woven%20basket%20with%20dried%20flowers%20soft%20afternoon%20sunlight%20through%20sheer%20curtains%20warm%20minimal%20Scandinavian%20interior%20editorial%20photography&width=800&height=500&seq=feat-shoes-v2-g7h2k&orientation=landscape',
  'Hoodies & Sweaters': 'https://readdy.ai/api/search-image?query=Oatmeal%20chunky%20knit%20sweater%20draped%20over%20a%20vintage%20wooden%20chair%20in%20front%20of%20textured%20plaster%20wall%20warm%20candlelight%20glow%20cozy%20autumn%20evening%20vibe%20cream%20and%20taupe%20tones%20editorial%20fashion%20photography&width=600&height=500&seq=feat-hoodies-v2-j4m9n&orientation=landscape',
  'T-Shirts': 'https://readdy.ai/api/search-image?query=Three%20perfectly%20folded%20organic%20cotton%20t-shirts%20in%20sage%20green%20terracotta%20and%20cream%20stacked%20on%20marble%20surface%20with%20eucalyptus%20branch%20bright%20natural%20daylight%20clean%20elevated%20product%20photography&width=600&height=500&seq=feat-tshirts-v2-p1q5r&orientation=landscape',
  'Jackets': 'https://readdy.ai/api/search-image?query=Classic%20denim%20jacket%20hanging%20on%20minimal%20wooden%20hanger%20against%20warm%20beige%20textured%20wall%20with%20drifting%20shadow%20from%20potted%20olive%20tree%20Mediterranean%20aesthetic%20soft%20natural%20backlight%20editorial%20quality&width=600&height=500&seq=feat-jackets-v2-s3t8v&orientation=landscape',
  'Bags': 'https://readdy.ai/api/search-image?query=Tan%20leather%20crossbody%20bag%20resting%20on%20a%20white%20linen%20bedsheet%20alongside%20a%20paperback%20book%20and%20reading%20glasses%20sunlight%20casting%20gentle%20shadows%20relaxed%20weekend%20morning%20aesthetic%20editorial%20photography&width=600&height=500&seq=feat-bags-v2-u6w2x&orientation=landscape',
  'Accessories': 'https://readdy.ai/api/search-image?query=Elegant%20gold%20watch%20and%20minimal%20jewelry%20pieces%20arranged%20on%20a%20travertine%20stone%20surface%20with%20a%20single%20white%20orchid%20bloom%20soft%20diffused%20natural%20light%20luxury%20minimal%20still%20life%20editorial%20photography&width=600&height=500&seq=feat-access-v2-y9z4a&orientation=landscape',
};

export default function FeaturedCategories() {
  return (
    <section className="bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-16 md:py-20">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-10 md:mb-14">
          <div>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950">
              Popular Categories
            </h2>
            <p className="text-foreground-500 text-sm mt-2">
              Discover trending products from our most visited categories
            </p>
          </div>
          <Link
            to="/articles/vigorbuy-spreadsheet-guide"
            className="text-sm font-medium text-primary-600 hover:text-primary-700 whitespace-nowrap cursor-pointer transition-colors"
          >
            View all guides <i className="ri-arrow-right-line ml-1 align-middle"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          <a
            href={featuredCategories[0].url}
            target="_blank"
            rel="noopener nofollow"
            className="group relative rounded-lg overflow-hidden h-72 md:h-80 md:col-span-2 cursor-pointer"
            data-product-shop
          >
            <img
              src={categoryImages['Shoes']}
              alt="Shoes on Vigorbuy Spreadsheet"
              title="Shoes - Vigorbuy Spreadsheet"
              className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-5">
              <h3 className="text-white text-xl font-semibold">Shoes</h3>
              <p className="text-white/70 text-sm mt-1">Latest sneakers, running shoes &amp; more</p>
            </div>
          </a>

          <a
            href={featuredCategories[1].url}
            target="_blank"
            rel="noopener nofollow"
            className="group relative rounded-lg overflow-hidden h-72 md:h-80 cursor-pointer"
            data-product-shop
          >
            <img
              src={categoryImages['Hoodies & Sweaters']}
              alt="Hoodies & Sweaters on Vigorbuy Spreadsheet"
              title="Hoodies & Sweaters - Vigorbuy Spreadsheet"
              className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-5">
              <h3 className="text-white text-lg font-semibold">Hoodies &amp; Sweaters</h3>
              <p className="text-white/70 text-sm mt-1">Cozy styles for every season</p>
            </div>
          </a>

          {featuredCategories.slice(2).map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group relative rounded-lg overflow-hidden h-56 md:h-64 cursor-pointer"
              data-product-shop
            >
              <img
                src={categoryImages[cat.name] || ''}
                alt={`${cat.name} on Vigorbuy Spreadsheet`}
                title={`${cat.name} - Vigorbuy Spreadsheet`}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-4">
                <h3 className="text-white text-base font-semibold">{cat.name}</h3>
                <p className="text-white/70 text-xs mt-1">Shop now on Vigorbuy</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}